var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"patent",attrs:{"to":{
        name: 'legalDetail',
        query: {
            id: _vm.info.id
        }
    }}},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.info.name)+" ")]),_c('div',{staticClass:"used"}),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.formatTime(_vm.info.issuedAt, 'YYYY.MM.DD')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }